<template>

   <div class="row mt-2 mb-2 text-center">
      <h6 class="card-subtitle text-muted">Proposal Version: <strong style="color:orange">{{ proposal.proposal_version
      }}</strong></h6>
   </div>

   <form ref="editBlockFormRef" class="row g-0">
      <LoadingPage v-if="isLoading"></LoadingPage>

      <div>
         <label for="organisation">
            Organisation
            <span v-if="proposal.organisation_source === 'linked_org' && (proposal.is_auth_sync || proposal.has_auth_organisation === 1 || proposal.has_auth_organisation === 2)" class="badge bg-info text-white ms-1" style="font-size: 10px;" :title="'Original Lead Name: ' + proposal.original_organisation_name">
               <i class="fa-solid fa-link me-1"></i>Linked Organisation
            </span>
            <span v-else-if="proposal.original_organisation_name && proposal.organisation_name !== proposal.original_organisation_name" class="badge bg-info text-white ms-1" style="font-size: 10px;" :title="'Original Lead Name: ' + proposal.original_organisation_name">
               <i class="fa-solid fa-history me-1"></i>Formerly: {{ proposal.original_organisation_name }}
            </span>
         </label>
         <input type="text" id="organisation" v-model="proposal.organisation_name" disabled class="form-control"
            placeholder="Organisation" />
      </div>

      <div>
         <label for="organisation_abn">
            Organisation ABN
            <span v-if="proposal.organisation_source === 'linked_org' && (proposal.is_auth_sync || proposal.has_auth_organisation === 1 || proposal.has_auth_organisation === 2)" class="badge bg-info text-white ms-1" style="font-size: 10px;" :title="'Original Lead ABN: ' + proposal.original_abn">
               <i class="fa-solid fa-link me-1"></i>Linked Organisation
            </span>
            <span v-else-if="proposal.original_abn && proposal.abn !== proposal.original_abn" class="badge bg-info text-white ms-1" style="font-size: 10px;" :title="'Original Lead ABN: ' + proposal.original_abn">
               <i class="fa-solid fa-history me-1"></i>Formerly: {{ proposal.original_abn }}
            </span>
         </label>
         <input type="text" id="organisation_abn" v-model="proposal.abn" disabled class="form-control"
            :placeholder="(proposal.abn) ? proposal.abn : 'No ABN'" />
      </div>

      <div>
         <label for="contract_id">Linked Contract ID</label>
         <input type="text" id="contract_id" v-model="proposal.contract_id" disabled class="form-control"
            :placeholder="(proposal.contract_id) ? proposal.contract_id : 'No Contract ID'" />
      </div>

      <div>
         <label for="proposal_owner">Proposal Owner</label>
         <input type="text" id="proposal_owner" v-model="proposal.proposal_owner" disabled class="form-control"
            placeholder="Proposal Owner" />
      </div>

      <div>
         <label for="client_lead_name">Client Lead Name</label>
         <input type="text" id="client_lead_name" v-model="proposal.client_lead_name" disabled class="form-control"
            placeholder="Lead Name" />
      </div>

      <div>
         <label for="client_lead_email">Client Lead Email</label>
         <input type="text" id="client_lead_email" v-model="proposal.client_lead_email" disabled class="form-control"
            placeholder="Lead Email" />
      </div>

      <div>
         <label for="value_quoted">Total Amount</label>
         <input type="text" id="value_quoted" v-model="proposal.total_amount" disabled class="form-control"
            placeholder="Value Quoted" />
      </div>

      <div>
         <label for="value_accepted">Accepted Amount</label>
         <input type="text" id="value_accepted" v-model="proposal.total_accepted" disabled class="form-control"
            placeholder="Value Accepted" />
      </div>

      <div>
         <label class="checkbox-label" @click.stop>
            <input type="checkbox" v-model="proposal.show_discount_calculation" class="styled-checkbox">
            <span class="checkbox-custom"></span>
            Show Discount Calculation on Proposal Landing Page?
         </label>
      </div>

      <div class="status-container">
         <div class="status-item">
            <label for="date_created">Date Created</label>
            <input type="text" id="date_created" v-model="proposal.created_at" disabled class="form-control"
               value="20-Sep-2025" />
         </div>
         <div class="status-item">
            <label for="date_sent">Date Sent</label>
            <input type="text" id="date_sent" v-model="proposal.sent_at" disabled class="form-control"
               :placeholder="(proposal.sent_at) ? proposal.sent_at : 'Not yet sent'" />
         </div>

         <div class="status-item full-width">
            <label>Shared With:</label>
            <div v-if="proposal.shared_users && proposal.shared_users.length > 0" class="shared-users-list">
               <div v-for="share in proposal.shared_users" :key="share.email" class="shared-user-item-inline">
                  <span class="shared-user-email">{{ share.email }}</span>
                  <span class="share-type-badge">{{ share.share_type }}</span>
               </div>
            </div>
            <div v-else>
               <p class="text-muted" style="margin-top: 5px;">Not shared with anyone yet.</p>
            </div>
         </div>
         <div class="status-item full-width">
            <label for="d_t_accepted">Date and Time Accepted</label>
            <input type="text" id="d_t_accepted" v-model="proposal.accepted_at" disabled class="form-control"
               :placeholder="(proposal.accepted_at) ? proposal.accepted_at : 'Not yet accepted'" />
         </div>

         <div class="status-item full-width">
            <label for="d_t_accepted">Expiry Date</label>
            <input type="text" id="d_t_accepted" v-model="proposal.expiry_date" disabled class="form-control"
               :placeholder="(proposal.expiry_date == null && DaysToAcceptCounter(proposal.expiry_date) < -1000) && proposal.sent_at != null ? 'Not yet sent' : proposal.expiry_date" />
         </div>

         <div class="acceptance-info">
            <div class="acceptance-item">
               <label for="accepted_by_email">Accepted by Email</label>
               <div v-if="this.proposal.accepted_by_email == null" class="acceptance-value no">Not yet accepted</div>
               <div v-else class="acceptance-value yes"> {{ this.proposal.accepted_by_email }}</div>
            </div>
            <div class="acceptance-item">
               <label for="accepted_by_ip">Accepted By IP Address</label>
               <div v-if="this.proposal.accepted_by_ip == null" class="acceptance-value no">Not yet accepted</div>
               <div v-else class="acceptance-value yes">{{ this.proposal.accepted_by_ip }}</div>
            </div>
         </div>
      </div>


   </form>

</template>

<script>
import moment from "moment";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
//  import { isEmpty } from '@/plugins/helper.js'
//  import 'vue-tel-input/dist/vue-tel-input.css'
//  import VueMultiselect from 'vue-multiselect'
//  import 'vue-multiselect/dist/vue-multiselect.css'
//  import "@/assets/scss/vue-multiselect.scss";
import LoadingPage from '@/components/Utilities/vertex-loading.vue'
import { nextTick } from 'vue'; // Import nextTick
import { debounce, formatCurrency, log, isEmpty } from '@/plugins/helper.js'

//const _ = require('lodash');

export default {

   components: {
      //    VueMultiselect,
      LoadingPage,
   },

   setup() {
      return { v$: useVuelidate() }
   },

   emits: ['onSubmit', 'onDelete', 'onInitializeDetails'],

   props: {
      item: {
         type: Object,
         // required: true,
      },
      id: {
         type: String,
      },
   },

   data() {
      return {
         currentDate: null,
         proposal: {
            created_date: null,
            organisation_name: "",
            abn: "",
            original_organisation_name: "",
            original_abn: "",
            contract_id: null,
            proposal_owner: null,
            proposal_title: "",
            client_lead_name: "",
            client_lead_email: "",
            total_amount: 0.00,
            total_accepted: 0.00,
            proposal_version: "",
            created_at: null,
            expiry_date: null,
            sent_at: null,
            accepted_at: null,
            content: "",
            proposal_items: [],
            proposal_section_sequence: [],
            proposal_status: 0,
            shared_users: [],
            accepted_by_email: null,
            renewed_from_proposal_uuid: null,
            is_extended: false,
            accepted_by_ip: null,
            option_index_selected: null,
         },
         productList: [],
         isEditing: false,
         disabledWhenClicked: false,
         isLoading: false,
         debounceFn: null,
         currentBlockType: "none",
         currentProposalName: "none",
         lead: null,
         bdm: null,
         ShowDiscountChanged: false,
         ShowDiscountCurrentValue: false,
         vtxUsers: [],
         rawInternalPricing: [],
         // Raw data straight from APIs
         rawAuthProducts: [],
         // All mapped products including parent-child definitions
         allMappedProducts: [],
         // Processed selection list (Right Table - ONLY ROOT ITEMS)
         availableProducts: [],
      }
   },

   validations() {
      return {
         block: {
            blockName: { required },
            blockType: { required },
            blockUse: { required },
         },
      }
   },

   computed: {

   },

   watch: {
      currentBlockType() {
         if (this.currentProposalName !== "none") {
            this.setHeaderTitle()
         }
      }
   },

   created() {
      this.init()
      this.debounceFn = debounce(() =>
         this.setContentIfNotEmpty()
         , 2500)
      this.setHeaderTitle()
   },

   mounted() {
      nextTick(() => {
         this.$parent.setContent(this.proposal.content, false)
      })
   },

   methods: {
      formatSectionLabel(type) {
         if (this.$parent && this.$parent.formatSectionLabel) {
            return this.$parent.formatSectionLabel(type);
         }
         const labels = {
            CoverPage: 'Cover Page Section',
            ProductService: 'Products & Services Section',
            PricingTable: 'Pricing Table Section',
            PricingTableIntro: 'Pricing Table Intro Section',
            PricingTableNotes: 'Pricing Table Notes Section',
            ImageGrid: 'Image Grid Section',
            Testimonials: 'Testimonials Section',
            SocialImpact: 'Social Impact Section',
            Commitment: 'Commitment to Safety and Compliance Section',
            WHS: 'WHS Responsibilities Section',
            TermsConditions: 'Terms & Conditions Section',
            NextSteps: 'Next Steps Section',
         };
         return labels[type] || (type + ' Section');
      },

      async init() {
         try {
            await Promise.all([
               this.getVertexUsers(),
               this.getInternalPricing(),
               this.getAuthProducts()
            ]);
            this.buildAvailableProductsList();
            this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         } catch (error) {
            console.error("Initialization failed", error);
         }
      },

      async getInternalPricing() {
         try {
            const response = await this.$axios.get("/get-product-pricing");
            this.rawInternalPricing = response.data.productPrices || [];
         } catch (error) {
            console.error("Failed to fetch internal pricing", error);
         }
      },


      formatDate(date) {
         if (!date || !moment(date).isValid() || moment(date).year() < 1980) {
            return null;
         }
         return moment(date).format("DD-MMM-YYYY @ HH:mm:ss");
      },

      formatDateNoTime(date) {
         if (!date || !moment(date).isValid() || moment(date).year() < 1980) {
            return null;
         }
         return moment(date).format("DD-MMM-YYYY");
      },

      formatUtcToTimeZone(utcDateString) {
         // 1. Parse the UTC date string into a Date object.
         // JavaScript Date objects internally represent time as milliseconds since the Unix epoch,
         // which is timezone-agnostic (effectively UTC).
         const date = new Date(utcDateString);

         // 2. Define formatting options.
         // 'timeZone' option tells Intl.DateTimeFormat to convert the date to this specific time zone.
         const options = {
            day: '2-digit',   // DD (e.g., 01, 15, 31)
            month: 'short',  // MMM (e.g., Jan, Feb, Dec)
            year: 'numeric',  // YYYY (e.g., 2023, 2025)
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            // Optional: timeZoneName: 'short' or 'long' if you want to include the time zone name
         };

         // 3. Create an Intl.DateTimeFormat instance and format the date.
         return new Intl.DateTimeFormat('en-US', options).format(date);
      },

      formatToTimestamp(date) {
         const day = date.getDate();
         const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
         const month = monthNames[date.getMonth()];
         const year = date.getFullYear();
         const hours = date.getHours().toString().padStart(2, '0');
         const minutes = date.getMinutes().toString().padStart(2, '0');
         const seconds = date.getSeconds().toString().padStart(2, '0');
         const formattedDate = `${day}-${month}-${year} @ ${hours}:${minutes}:${seconds}`;

         if (year < 1980) {
            return null;
         }

         return formattedDate;
      },

      /**
* Calculates the number of calendar days between the current date (now) and an expiry date.
* The calculation considers full calendar days, meaning it normalizes both dates to the
* start of their respective days in the user's local timezone.
*
* @param {string} utcDateString The expiry date string in UTC format (e.g., "2025-06-08T05:00:00Z").
* @returns {number} The difference in full calendar days.
* Positive if the expiry date is in the future, negative if in the past.
* 0 if it's the same calendar day.
*/
      DaysToAcceptCounter(utcDateString) {
         // 1. Get the expiry date as a Date object.
         //    It's parsed from a UTC string, but the Date object itself stores a universal timestamp.
         const expiryDate = new Date(utcDateString);

         // 2. Get the current date and time in the user's local timezone.
         const now = new Date();

         // 3. To accurately count "calendar days" (days on the calendar, ignoring time of day),
         //    we need to determine the start of the day for both 'now' and 'expiryDate'
         //    in the *user's local timezone*.

         //    Create a new Date object representing the start of the current day (00:00:00)
         //    in the user's local timezone. By passing year, month, and day to the Date constructor,
         //    it automatically creates a date in the local timezone at midnight.
         const startOfTodayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());

         //    Create a new Date object representing the start of the expiry day (00:00:00)
         //    in the user's local timezone.
         //    We extract the year, month, and date components from the 'expiryDate' using its local getters
         //    (e.g., `getFullYear()`, `getMonth()`, `getDate()`). These getters automatically
         //    convert the internal UTC timestamp to the corresponding local calendar day.
         //    Then, creating a new Date object with these local components ensures we get the
         //    midnight of that specific local calendar day.
         const startOfExpiryDayLocal = new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate());

         // 4. Calculate the difference in milliseconds between these two "start-of-day" timestamps.
         const differenceInMs = startOfExpiryDayLocal.getTime() - startOfTodayLocal.getTime();

         // 5. Convert the millisecond difference to days.
         //    We divide by the number of milliseconds in a standard day (24 hours).
         const millisecondsPerDay = 1000 * 60 * 60 * 24;
         let daysDifference = differenceInMs / millisecondsPerDay;

         // 6. Round the result to the nearest whole number.
         //    Using Math.round() helps in handling any minor floating-point inaccuracies or
         //    cases where a "day" might be slightly more or less than 24 hours due to
         //    Daylight Saving Time (DST) transitions. This ensures we get clear whole calendar day counts.
         return Math.round(daysDifference);
      },

      editProposal(id) {
         this.getProposal(id)
      },

      triggerDebounce() {
         this.debounceFn()
      },

      async setContentIfNotEmpty() {
         this.isLoading = true
         setTimeout(() => {
            this.isLoading = false
            //this.toggleIsLoading()
            let generatedContent = this.buildContent()

            if (generatedContent != undefined && generatedContent != null) {
               this.$parent.setContent(generatedContent, false)
            }

            //if (this.proposal.content != undefined && this.proposal.content != null) {
            //this.$parent.setContent(this.proposal.content, false)
            //}
         }, 2500)
      },

      buildContent() {
         // 1. Setup the data sources
         const sectionsData = this.proposal.proposal_section_content || {};
         const items = this.proposal.proposal_items || [];

         // Local helpers to mimic VertexProposal's exact computed properties
         const calcTotalDiscount = (p) => (p.discount * p.quantity) || 0;
         const calcTotal = (p) => ((p.pricing * p.quantity) - calcTotalDiscount(p)) || 0;
         const calcSubTotal = (list) => list.reduce((total, p) => (p.item_hidden || (p.isChild && parseFloat(p.pricing) <= 0)) ? total : total + calcTotal(p), 0);
         const calcGST = (list) => calcSubTotal(list) * 0.10;
         const calcGrandTotal = (list) => calcSubTotal(list) * 1.10;

         // 1. Rebuild the arrays and determine isChild dynamically using allMappedProducts
         let optionsMap = {};

         items.forEach(item => {
            // Skip hidden items
            if (item.item_hidden === true || item.item_hidden === 1 || item.item_hidden === "1") return;

            let optIdx = item.option_index || 1;
            if (!optionsMap[optIdx]) optionsMap[optIdx] = [];

            // RESOLVE ID: Match ClientProposal's logic for UUID -> AuthCode mapping
            let targetId = String(item.product_id || item.id);
            if (this.rawInternalPricing && this.rawInternalPricing.length > 0) {
               const internalMap = this.rawInternalPricing.find(ip => 
                  String(ip.product_id || ip.ProductID || ip.id) === targetId || 
                  String(ip.auth_item_code || ip.AuthItemCode) === targetId
               );
               if (internalMap) {
                  const isAuthLinked = internalMap.has_auth_product_linked == 1 || internalMap.HasAuthProductLinked == 1 || internalMap.has_auth_product_linked === true || internalMap.HasAuthProductLinked === true;
                  if (isAuthLinked && (internalMap.AuthItemCode || internalMap.auth_item_code)) {
                     targetId = String(internalMap.AuthItemCode || internalMap.auth_item_code);
                  }
               }
            }

            let mappedProd = (this.allMappedProducts || []).find(mp => String(mp.id) === targetId);

            // Bulletproof isChild determination: Direct catalog check + Database flag + Direct Internal Pricing check
            let isChild = false;
            
            // 1. Check catalog mapping (merged from internal)
            if (mappedProd && mappedProd.parentIds && mappedProd.parentIds.length > 0) {
               isChild = true;
            } 
            // 2. Check direct database flags
            else if (item.is_child === true || item.is_child === 1 || String(item.is_child) === "true" || item.isChild === true || item.isChild === 1 || String(item.isChild) === "true") {
               isChild = true;
            } 
            // 3. Direct Internal Pricing Lookup (Failsafe for missing catalog items)
            else if (this.rawInternalPricing && this.rawInternalPricing.length > 0) {
               const internalMap = this.rawInternalPricing.find(ip => 
                  String(ip.product_id || ip.ProductID || ip.id) === String(item.product_id || item.id) || 
                  String(ip.auth_item_code || ip.AuthItemCode) === String(item.product_id || item.id)
               );
               if (internalMap) {
                  let pIds = internalMap.ParentProductIDs || internalMap.parent_product_ids || internalMap.ParentProductID || internalMap.parent_product_id || null;
                  if (pIds) {
                     if (typeof pIds === 'string') {
                        try { pIds = JSON.parse(pIds); } catch(e) { pIds = pIds ? [pIds] : []; }
                     }
                     if (Array.isArray(pIds)) {
                        if (pIds.filter(id => id && id !== '').length > 0) isChild = true;
                     } else if (pIds && pIds !== "") {
                        isChild = true;
                     }
                  }
               }
            }
            // 4. Heuristic Fallback
            if (!isChild && parseFloat(item.price || item.pricing || 0) === 0 &&
               parseFloat(item.discount || 0) === 0 &&
               String(item.description || "").toLowerCase().includes("complimentary")) {
               isChild = true;
            }

            // Apply enforced 0 for children unless they have a price > 0
            let rawPrice = parseFloat(item.price || item.pricing || 0);
            let rawDiscount = parseFloat(item.discount || 0);
            let price = (isChild && rawPrice <= 0) ? 0 : rawPrice;
            let discount = (isChild && rawPrice <= 0) ? 0 : rawDiscount;
            let quantity = parseInt(item.quantity || 1);

            optionsMap[optIdx].push({
               id: item.product_id || item.id,
               product: mappedProd?.name || item.product_name || item.Product.name || "Unknown Product",
               description: item.description || mappedProd?.description || "No Product Description",
               remarks: item.remarks || "No Remarks",
               quantity: quantity,
               pricing: price,
               discount: discount,
               isChild: isChild
            });
         });

         // 2. Build the Tables exactly mirroring VertexProposal's HTML
         let pricingTableMainHTML = "";
         let optionsToPropagate = "";

         const sortedIndices = Object.keys(optionsMap).map(Number).sort((a, b) => a - b);

         sortedIndices.forEach(optIdx => {
            let list = optionsMap[optIdx];
            let productsToPropagate = "";

            list.forEach(p => {

               // Child Arrow & Indentation Formatting
                let productCell = p.isChild
                   ? `<div style="padding-left: 15px; display: flex; align-items: center; color: #555;">
                  <span style="color: #00a0c1; font-weight: bold; margin-right: 8px; font-size: 1.2em;">&#9658;</span> 
                  <span>${p.product}</span>
                </div>`
                   : `<b>${p.product}</b>`;

               // "Included" Tag Formatting for Children
               let priceCell = (p.isChild && parseFloat(p.pricing) <= 0) ? `<span style="color: #00a0c1; font-weight: bold;">Included</span>` : this.formatCurrency(p.pricing);
               let discountCell = (p.isChild && parseFloat(p.pricing) <= 0) ? "" : this.formatCurrency(p.discount);
               let totalDiscountCell = (p.isChild && parseFloat(p.pricing) <= 0) ? "" : this.formatCurrency(calcTotalDiscount(p));
               let totalCell = (p.isChild && parseFloat(p.pricing) <= 0) ? `<span style="color: #00a0c1; font-weight: bold;">Included</span>` : this.formatCurrency(calcTotal(p));

               productsToPropagate += `
            <tr id='product_list_${p.id}'>
              <td style="border-color: black; border-width: 1px; text-align: left; padding-left: 8px;">${productCell}</td>
              <td style="border-color: black; border-width: 1px; text-align: left; padding-left: 8px;">${p.description}</td>
              <td style="border-color: black; border-width: 1px; text-align: left; padding-left: 8px;">${p.remarks}</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${p.quantity}</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${priceCell}</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${discountCell}</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${totalDiscountCell}</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${totalCell}</td>
            </tr>`;
            });

            productsToPropagate += `
          <tr>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;"><b>Subtotal</b></td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(calcSubTotal(list))}</td>
          </tr>
          <tr>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td title="Goods and Services Tax" style="border-color: black; border-width: 1px; text-align: center;"><b>GST (10%)</b></td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(calcGST(list))}</td>
          </tr>
          <tr>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
               <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
              <td style="border-color: black; border-width: 1px; text-align: center;"><b>Total AUD</b></td>
              <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(calcGrandTotal(list))}</td>
          </tr>`;

            let fullTable = `
          <div style="text-align: left; margin-bottom: 8px; margin-top: 20px;">
             <span class="orange-label-product-option" style="display: inline-block; background-color: #ff8c00; color: white; padding: 6px 12px; border-radius: 5px; font-weight: bold; font-size: 0.95em; text-transform: uppercase; letter-spacing: 0.5px;">
               Pricing for Option ${this.toOptionName ? this.toOptionName(optIdx) : optIdx}
             </span>
          </div>
          <table style="border-collapse: collapse; width: 100%; border-color: black; border: 2px solid black;" border="1">
            <thead>
              <tr>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: left; padding-left: 8px;">Product</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Description</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Notes</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Qty</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Price</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Per Item Discount</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total Discount</th>
                <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total AUD</th>
              </tr>
            </thead>
            <tbody>
               ${productsToPropagate}
            </tbody>
          </table>`;

            if (optIdx === 1) {
               // If it's the main table, we strip the orange label div out
               pricingTableMainHTML = fullTable.replace(/<div style="text-align: left; margin-bottom: 8px; margin-top: 20px;">[\s\S]*?<\/div>/, "");
            } else {
               optionsToPropagate += fullTable;
            }
         });
         if (!pricingTableMainHTML) {
            pricingTableMainHTML = `<p style="text-align: center;"><em>No products selected for this proposal.</em></p>`;
         }

         let allPricingTables = pricingTableMainHTML + optionsToPropagate;

         // 3. Assemble the full template mapping (JSON blocks if available, else legacy fallback)
         if (this.$parent && this.$parent.proposalSections && this.$parent.proposalSections.length > 0) {
            let activeBlocksHTML = [];
            const idMap = this.$parent.SECTION_ID_MAP();
            
            this.$parent.proposalSections.forEach(section => {
               if (section.is_hidden) return;
               const sectionType = section.type;
               let sectionBody = section.content || '';
               const sectionId = idMap[sectionType] || ('start_' + sectionType.toLowerCase() + '_section');
               const label = this.formatSectionLabel(sectionType);

               const sectionTypeLower = sectionType.toLowerCase();
               let wrapperId = `${sectionTypeLower}_page_section`;
               if (sectionType === "CoverPage") wrapperId = "cover_page_section";
               if (sectionType === "ProductService") wrapperId = "product_services_section";
               if (sectionType === "PricingTableIntro" || sectionType === "PricingTableNotes") wrapperId = "pricing_table_section";
               if (sectionType === "ImageGrid") wrapperId = "image_grid_section";
               if (sectionType === "SocialImpact") wrapperId = "content_social_impact_section";
               if (sectionType === "Commitment") wrapperId = "content_commitment_section";
               if (sectionType === "TermsConditions") wrapperId = "content_terms_condition_section";
               if (sectionType === "NextSteps") wrapperId = "content_next_steps_section";

               let labelId = `${sectionTypeLower}_section_label`;
               if (sectionType === "CoverPage") labelId = "cover_section_label";
               if (sectionType === "ProductService") labelId = "product_services_section_label";
               if (sectionType === "PricingTableIntro" || sectionType === "PricingTableNotes") labelId = "pricing_table_section_label";
               if (sectionType === "ImageGrid") labelId = "image_grid_section_label";
               if (sectionType === "SocialImpact") labelId = "social_impact_section_label";
               if (sectionType === "Commitment") labelId = "commitment_section_label";
               if (sectionType === "TermsConditions") labelId = "terms_condition_section_label";
               if (sectionType === "NextSteps") labelId = "next_steps_section_label";

               if (sectionType === "PricingTable") {
                  activeBlocksHTML.push(`
                     <section id='pricing_table_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                           <p style='color: #00A0C1; font-weight: bold; margin: 0; cursor: default;' id='pricing_table_section_label'>Pricing Table Section</p>
                           <button type="button" class="btn-open-pricing-modal" style="background-color: #00A0C1; color: #ffffff; border: 1px solid #008fae; padding: 4px 12px; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.08);">
                              <i class="fa-solid fa-pen-to-square"></i> Edit Pricing Table
                           </button>
                        </div>
                        <div id='start_pricing_table_section' class='non-editable-section' contenteditable="false" style="background-color: #f9f9f9; padding: 20px; text-align: center; border: 1px solid #ddd; margin-bottom: 15px;">
                           ${allPricingTables}
                        </div>
                     </section>`);
               } else if (sectionType === "Testimonials") {
                  activeBlocksHTML.push(`
                     <section id='testimonial_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
                        <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='testimonial_section_label'>Testimonials Section</p>  
                        <div id='start_testimonial_main' class='non-editable-section' contenteditable="false" style="background-color: #f9f9f9; padding: 30px; text-align: center; border: 1px solid #ddd; border-radius: 4px;">
                           <h3 style='color: #435666; margin: 0; font-family: sans-serif;'>[Automated Testimonials Placeholder]</h3>
                           <p style="font-size: 13px; color: #666; font-family: sans-serif; margin-top: 5px;">Client testimonials will be automatically rendered here on the final proposal landing page.</p>
                        </div>
                     </section>`);
               } else {
                  activeBlocksHTML.push(`
                     <section id='${wrapperId}' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;"> 
                        <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='${labelId}' disabled>${label}</p>
                        <div id='${sectionId}' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
                           ${sectionBody || "<p><br></p>"}
                        </div>
                     </section>`);
               }
            });
            return activeBlocksHTML.join(`\n<hr style="border-top: 1px solid #eee; margin: 20px 0;">\n`);
         }

         // 1. Define your sequence (In the future, this comes from this.proposal.section_sequences!)
      // For now, we will define the default fallback order here:
      let sectionSequences = (this.proposal.proposal_section_sequence || [
        { section_name: "CoverPage", sequence: 1, is_hidden: false },
        { section_name: "ProductService", sequence: 2, is_hidden: false },
        { section_name: "PricingTable", sequence: 3, is_hidden: false },
        { section_name: "ImageGrid", sequence: 4, is_hidden: false },
        { section_name: "Testimonials", sequence: 5, is_hidden: false },
        { section_name: "SocialImpact", sequence: 6, is_hidden: false },
        { section_name: "Commitment", sequence: 7, is_hidden: false },
        { section_name: "TermsConditions", sequence: 8, is_hidden: false },
        { section_name: "NextSteps", sequence: 9, is_hidden: false }
      ]).filter(seq => seq.section_name !== 'WHS');

      // 2. Sort the array by sequence number just to be safe
      sectionSequences.sort((a, b) => a.sequence - b.sequence);

      // 3. Create a Dictionary/Map of all your raw section HTML blocks
      const sectionBlocks = {
        CoverPage: `
          <section id='cover_page_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;"> 
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='cover_section_label' disabled>Cover Section</p>
            <div id='start_cover_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.cover_page_content_draft || "<p><br></p>"}
            </div>
          </section>`,
          
        ProductService: `
          <section id='product_services_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='product_services_section_label' disabled>Product & Services Section</p> 
            <div id='start_product_services_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.product_service_content_draft || "<p><br></p>"}
            </div>
          </section>`,
          
        PricingTable: `
          <section id='pricing_table_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
               <p style='color: #00A0C1; font-weight: bold; margin: 0; cursor: default;' id='pricing_table_section_label'>Pricing Table Section</p>
               <button type="button" class="btn-open-pricing-modal" style="background-color: #00A0C1; color: #ffffff; border: 1px solid #008fae; padding: 4px 12px; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.08);">
                  <i class="fa-solid fa-pen-to-square"></i> Edit Pricing Table
               </button>
            </div>
            <div id='start_pricing_table_intro' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none; margin-bottom: 15px;">
               ${sectionsData.pricing_table_introduction_content_draft || "<p><em>[Enter your introductory text for the pricing table here...]</em></p>"}
            </div>
            <div id='start_pricing_table_section' class='non-editable-section' contenteditable="false" style="background-color: #f9f9f9; padding: 20px; text-align: center; border: 1px solid #ddd; margin-bottom: 15px;">
               ${allPricingTables}
            </div>
            <div id='start_pricing_table_notes' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
               ${sectionsData.pricing_table_notes_content_draft || "<p><em>[Enter any concluding remarks or notes below the pricing table here...]</em></p>"}
            </div>
          </section>`,
          
        ImageGrid: `
          <section id='image_grid_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='image_grid_section_label'>Image Grid Section</p>  
            <div id='start_image_grid_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.image_grid_content_draft || "<p><br></p>"}
            </div>  
          </section>`,
          
        Testimonials: `
          <section id='testimonial_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='testimonial_section_label'>Testimonials Section</p>  
            <div id='start_testimonial_main' class='non-editable-section' contenteditable="false" style="background-color: #f9f9f9; padding: 30px; text-align: center; border: 1px solid #ddd; border-radius: 4px;">
              <h3 style='color: #435666; margin: 0; font-family: sans-serif;'>[Automated Testimonials Placeholder]</h3>
              <p style="font-size: 13px; color: #666; font-family: sans-serif; margin-top: 5px;">Client testimonials will be automatically rendered here on the final proposal landing page.</p>
            </div>
          </section>`,
          
        SocialImpact: `
          <section id='content_social_impact_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='social_impact_section_label'>Social Impact Section</p>  
            <div id='start_content_social_impact_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.content_social_impact_draft || "<p><br></p>"}
            </div>  
          </section>`,
          
        Commitment: `
          <section id='content_commitment_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='commitment_section_label'>Commitment to Safety and Compliance Section</p>  
            <div id='start_content_commitment_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.content_commitment_draft || "<p><br></p>"}
            </div>  
          </section>`,
          
        WHS: `
          <section id='content_whsr_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='whsr_section_label'>Workplace Health & Safety Responsibilities Section</p>  
            <div id='start_content_whsr_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.content_whs_responsibilities_draft || "<p><br></p>"}
            </div>  
          </section>`,
          
        TermsConditions: `
          <section id='content_terms_condition_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='terms_condition_section_label'>Terms & Conditions Section</p>  
            <div id='start_content_terms_condition_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.content_terms_conditions_draft || "<p><br></p>"}
            </div>  
          </section>`,
          
        NextSteps: `
          <section id='content_next_steps_section' class='non-editable-section' contenteditable="false" style="user-select: none; margin-bottom: 20px;">
            <p style='text-align:center; color: #00A0C1; font-weight: bold; margin-bottom: 5px; cursor: default;' id='next_steps_section_label'>Next Steps</p>  
            <div id='start_content_next_steps_section' class='editable-content-inside' contenteditable="true" style="user-select: text; min-height: 50px; padding: 10px; border: 1px dashed #ccc; background-color: #fff; display: block; outline: none;">
              ${sectionsData.content_next_steps_draft || "<p><br></p>"}
            </div>  
          </section>`
      };

      // 4. Loop through the sequence, pick the active blocks, and put them in an array
      let activeBlocksHTML = [];
      
      sectionSequences.forEach(seq => {
        // Only add the block if it's NOT hidden, and if the block actually exists in our dictionary
        if (!seq.is_hidden && sectionBlocks[seq.section_name]) {
          activeBlocksHTML.push(sectionBlocks[seq.section_name]);
        }
      });

      // 5. Join the active blocks together using your <hr> divider!
      // This automatically prevents double <hr> lines when a section is hidden.
      let finalSectionsHTML = activeBlocksHTML.join(`\n<hr style="border-top: 1px solid #eee; margin: 20px 0;">\n`);
      return finalSectionsHTML;
      },

      calculateTotal(item) {
         // Correctly calculates (price - discount) * quantity for a single row
         const price = parseFloat(item.price) || 0;
         const discount = parseFloat(item.discount) || 0;
         const quantity = parseInt(item.quantity) || 0;
         return (price - discount) * quantity;
      },

      calculateOptionSubtotalPrice(productList) {
         // Correctly sums the total of each row to get the subtotal
         return productList.reduce((total, item) => {
            return total + this.calculateTotal(item);
         }, 0);
      },

      calculateOptionGST(productList) {
         // Calculates 10% of the correct subtotal
         return this.calculateOptionSubtotalPrice(productList) * 0.1;
      },

      calculateOptionTotalPrice(productList) {
         // Calculates the subtotal plus GST
         return this.calculateOptionSubtotalPrice(productList) * 1.1;
      },

      formatCurrency(value) {
         const numericValue = parseFloat(value);
         if (isNaN(numericValue)) {
            return '$0.00';
         }
         return `$${numericValue.toFixed(2)}`;
      },

      calculateTotalDiscount(item) {
         return (item.discount * item.quantity);
      },

      toOptionName(count) {
         // Handle the special case: if count is 1, return an empty string
         if (count <= 1) {
            return '';
         }

         let result = '';
         let num = count; // Start with the actual count for conversion

         while (num > 0) {
            // Calculate the remainder when dividing by 26
            // This gives us the position of the current letter (1 for A, 26 for Z)
            let remainder = num % 26;

            // Adjustment for 'Z' and subsequent columns:
            // If remainder is 0, it means the letter is 'Z' (the 26th letter)
            // and we need to decrement num by 26 to properly carry over for the next iteration.
            if (remainder === 0) {
               remainder = 26; // Map 0 remainder to the 26th letter ('Z')
            }

            // Convert the remainder to a character
            // 'A' has ASCII value 65. So, (remainder - 1) + 65 gives us the correct character code
            // (e.g., if remainder is 1, 1-1=0, 65+0=65='A')
            result = String.fromCharCode(64 + remainder) + result;

            // Update num for the next iteration
            // If remainder was 26 (meaning 'Z'), we effectively processed a full '26' group.
            // So, subtract 'remainder' and then divide by 26.
            num = Math.floor((num - remainder) / 26);
         }

         return result;
      },

      async getAuthProducts() {
         try {
            const response = await this.$axios.get("/proposal/get-auth-products");
            this.rawAuthProducts = response.data.authProducts || [];
         } catch (error) {
            console.error("Failed to fetch auth products", error);
         }
      },

      buildAvailableProductsList() {
         this.availableProducts = [];
         this.allMappedProducts = [];

         this.rawAuthProducts.forEach(authItem => {
            if (!authItem.Product) return;

            let price = authItem.Product.price ?? authItem.Product.Price ?? authItem.price ?? authItem.Price ?? 0;
            let description = authItem.Product.description ?? authItem.Product.Description ?? authItem.description ?? "No Product Description";
            let name = authItem.Product.display_name ?? authItem.Product.name ?? "No Name";
            let isCharity = authItem.is_charity_product === true || authItem.is_charity_product == 1;

            // Grab parent_product_ids from the auth payload (supports both old string and new array format)
            let parentIds = authItem.parent_product_ids || authItem.ParentProductIDs || authItem.parent_product_id || authItem.ParentProductID || null;
            if (typeof parentIds === 'string') {
               try { parentIds = JSON.parse(parentIds); } catch(e) { parentIds = parentIds ? [parentIds] : []; }
            }
            if (!Array.isArray(parentIds)) parentIds = parentIds ? [parentIds] : [];
            parentIds = parentIds.filter(id => id && id !== '');

            this.allMappedProducts.push({
               id: authItem.product_id || authItem.Product.id,
               name: name,
               defaultPricing: price,
               description: description,
               defaultQuantity: 1,
               isCharityProduct: isCharity,
               parentIds: parentIds,
               pricingPlanType: authItem.pricing_plan_type || (authItem.Product && authItem.Product.pricing_plan_type) || ""
            });
         });

         // NEW: Merge parent-child relationships from rawInternalPricing into allMappedProducts
         this.allMappedProducts.forEach(p => {
            const internalMatches = this.rawInternalPricing.filter(ip => 
               String(ip.product_id || ip.ProductID || ip.id) === String(p.id) || 
               String(ip.auth_item_code || ip.AuthItemCode) === String(p.id)
            );
            
            internalMatches.forEach(ip => {
               let ipParentIds = ip.ParentProductIDs || ip.parent_product_ids || ip.ParentProductID || ip.parent_product_id || null;
               if (ipParentIds) {
                  if (typeof ipParentIds === 'string') {
                     try { ipParentIds = JSON.parse(ipParentIds); } catch(e) { ipParentIds = [ipParentIds]; }
                  }
                  if (!Array.isArray(ipParentIds)) ipParentIds = [ipParentIds];
                  
                  ipParentIds.forEach(pid => {
                     if (pid && !p.parentIds.includes(pid)) p.parentIds.push(pid);
                  });
               }
            });
         });

         // Show ONLY parent products (roots) in the right selection table
         // Failsafe: If a child's parent doesn't exist in the list, treat the child as a root so it isn't hidden forever
         this.availableProducts = this.allMappedProducts.filter(p => {
            if (!p.parentIds || p.parentIds.length === 0) return true;

            const parentExists = p.parentIds.some(pid => this.allMappedProducts.some(parent => parent.id === pid));
            return !parentExists;
         });

         this.availableProducts.sort((a, b) => a.name.localeCompare(b.name));
      },

      async setHeaderTitle() {
         this.$parent.setHeaderTitle(this.currentProposalName)
      },

      toggleIsLoading() {
         this.isLoading = !this.isLoading
      },

      getInternalAccessKey() {
         return this.proposal.internal_key
      },

      getUniqueKey() {
         return this.proposal.unique_key
      },

      async getProposal(id) {
         this.isLoading = true;

         await this.$axios.get("/proposals/" + id)
            .then((response) => {
               let resp = response.data.vertex_proposal
               this.proposal.id = resp.id
               this.proposal.unique_key = resp.unique_key
               this.proposal.internal_key = resp.internal_key
               this.proposal.content = resp.content
               this.proposal.created_date = resp.created_at
               let acceptedOrgName = ""
               let acceptedAbn = ""
               if (resp.contract_acceptances && resp.contract_acceptances.length > 0) {
                  acceptedOrgName = resp.contract_acceptances[0].organisation_name
                  acceptedAbn = resp.contract_acceptances[0].abn
               }
                let leadOrgName = resp.Lead ? (resp.Lead.auth_organisation_name || resp.Lead.organisation_name) : ""
                let leadAbn = resp.Lead ? resp.Lead.abn : ""
                let originalLeadOrgName = resp.Lead ? (resp.Lead.original_organisation_name || "") : ""
                let originalLeadAbn = resp.Lead ? (resp.Lead.original_abn || "") : ""

                let linkedOrgName = resp.auth_organisation ? resp.auth_organisation.name : ""
                let linkedOrgAbn = resp.auth_organisation ? resp.auth_organisation.abn : ""

                let source = "default"
                if (linkedOrgName) {
                   source = "linked_org"
                } else if (acceptedOrgName) {
                   source = "acceptance"
                }

                this.proposal.organisation_source = source
                this.proposal.organisation_name = linkedOrgName || acceptedOrgName || leadOrgName
                this.proposal.abn = linkedOrgAbn || acceptedAbn || leadAbn
                this.proposal.original_organisation_name = originalLeadOrgName
                this.proposal.original_abn = originalLeadAbn
                this.proposal.is_auth_sync = resp.is_auth_sync || false
                this.proposal.contract_id = resp.contract_id
               this.proposal.proposal_owner = this.getVertexAuthUser(resp.created_by)
               this.proposal.proposal_title = resp.proposal_title
               this.proposal.client_lead_name = resp.Lead.first_name + " " + resp.Lead.last_name
               this.proposal.client_lead_email = resp.Lead.email
               this.proposal.total_amount = formatCurrency(resp.proposal_total_amount)
               this.proposal.total_accepted = formatCurrency(resp.proposal_accepted_amount)
               this.proposal.expiry_date = (resp.expiry_date != null) ? this.formatDateNoTime(resp.expiry_date) : null
               this.proposal.proposal_version = resp.proposal_version
               this.proposal.created_at = this.formatDate(resp.created_at)
               this.proposal.sent_at = (resp.sent_at != null) ? this.formatDate(resp.sent_at) : null
               this.proposal.accepted_at = (resp.accepted_at != null) ? this.formatDate(resp.accepted_at) : null
               this.proposal.proposal_status = (resp.proposal_status != null && resp.proposal_status != undefined) ? resp.proposal_status : null
               this.proposal.show_discount_calculation = resp.show_discount_calculation
               this.proposal.proposal_section_content = resp.proposal_section_content
               this.ShowDiscountCurrentValue = resp.show_discount_calculation
               this.lead = resp.Lead
               this.bdm = resp.bdm || null
               this.currentProposalName = this.proposal.proposal_title
               this.setHeaderTitle()
               this.proposal.proposal_items = resp.proposal_items
               this.proposal.proposal_section_sequence = resp.proposal_section_sequence
               this.proposal.shared_users = resp.shared_users || []
               this.proposal.accepted_by_email = resp.accepted_by_email || null
               this.proposal.accepted_by_ip = resp.accepted_by_ip || null
               this.proposal.option_index_selected = resp.option_index_selected || null
               this.proposal.renewed_from_proposal_uuid = resp.renewed_from_proposal_uuid || null
               this.proposal.is_extended = resp.is_extended || false
               this.$emit('onInitializeDetails')
               this.isLoading = false;
            }).catch((error) => {
               this.$toast.error(error)
               this.isLoading = false;
            })
      },

      getVersion() {
         return this.proposal.proposal_version
      },

      getProposalItems() {

         if (!isEmpty(this.proposal.proposal_items)) {
            this.proposal.proposal_items.forEach(prop_item => {
               prop_item['is_charity'] = this.lead.is_charity
            })

            return this.proposal.proposal_items
         }

         return []
      },

      isShowDiscountChanged() {
         return this.ShowDiscountCurrentValue == this.proposal.show_discount_calculation
      },


      async updateProposal(proposal_section_content) {

         log("proposal_id", this.proposal.id)

         proposal_section_content["show_discount_calculation"] = this.proposal.show_discount_calculation

         await this.$axios.put("/proposals/" + this.proposal.id + "/update-content", proposal_section_content)
            .then((response) => {
               if (response.data.success) {
                  this.isLoading = true
                  this.editProposal(this.proposal.id)
                  this.isLoading = false
                  this.$parent.clearIsDirty()
                  //this.ShowDiscountChanged = false
                  this.$toast.success(response.data.message)
               } else {
                  this.isLoading = false
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.isLoading = false
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      async sendProposal() {

         log("proposal_id", this.proposal.id)

         await this.$axios.put("/proposals/" + this.proposal.id + "/send")
            .then((response) => {
               if (response.data.success) {
                  this.isLoading = true
                  this.editProposal(this.proposal.id)
                  this.isLoading = false
                  this.$toast.success(response.data.message)
               } else {
                  this.isLoading = false
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.isLoading = false
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      getVertexAuthUser(id) {
         //this.vtxUsers = this.$store.state.auth.usersWithVertexRoles
         let user = Array.isArray(this.vtxUsers) ? this.vtxUsers.find(user => user && user.id === id) : null;
         if (user) {
            return user.first_name + " " + user.last_name
         } else if (user == null && id != "") {
            return "Deleted User"
         } else {
            return "System Generated"
         }
      },

      getVertexUsers() {
         this.vtxUsers = this.$store.state.auth.usersWithVertexRoles || []
         // await this.$axios_auth.get("/supadmin/users")
         //    .then((response) => {
         //       sortAlphabetically(response.data.users, (item) => item.user.first_name)
         //       this.vtxUsers = response.data.users
         //       //this.$store.commit("auth/setUsersWithVertexRoles", response.data.users)
         //    })
         //    .catch((error) => {
         //       console.error(error)
         //       // this.$toast.error(error.response.data.message)
         //    })
      },

      resetForm() {
         this.proposal = null
      },
   },

};

</script>

<style scoped>
.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #F3994D;
}

select>option {
   color: #435666;
   /* border: 1px solid #D9D9D9; */
   /* border-radius: 5px; */
}

.btn {
   width: 7rem;
}

form label:not(#isCharityLbl) {
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]),
select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.form--check-label {
   /* Adjust spacing between checkbox and label */
   color: #495057 !important;
   font-size: 15px;
   align-items: center;
   /* Vertically center the content */
   justify-content: center;
   /* Horizontally center the content */
   /* Grayish color for the label */
}

.form--check-input {
   width: 12px;
   /* Increase width */
   height: 12px;
   /* Increase height */
   margin-left: -17px;
   margin-right: 10px;
}

.add-space {
   margin-bottom: 225px;
}

.btn-circle-color {
   width: 40px;
   height: 40px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #00A0C1;
   color: #00A0C1;
}

.status-container {
   display: grid;
   grid-template-columns: auto auto;
   /* Creates two equal width columns */
   gap: 10px;
   /* Adds some space between the grid items */
   padding: 15px;
   background-color: #f7f7f7;
   /* Light background */
   border-radius: 8px;
   /* Rounded corners */
}

.status-item {
   display: flex;
   flex-direction: column;
   padding: 10px;
   background-color: white;
   /* Slightly darker background for items */
   border-radius: 5px;
}

.full-width {
   grid-column: 1 / -1;
   /* Make this item span both columns */
}

.status-label {
   font-size: 0.85em;
   color: #555;
   margin-bottom: 5px;
}

.status-value {
   font-weight: bold;
   color: #333;
}

.acceptance-info {
   grid-column: 1 / -1;
   /* Span both columns */
   display: flex;
   gap: 10px;
   margin-top: 10px;
}

.acceptance-item {
   display: flex;
   flex-direction: column;
   flex: 1;
   /* Distribute available space equally */
   padding: 10px;
   background-color: white;
   border-radius: 5px;
   text-align: center;
   /* Center the content */
}

.acceptance-label {
   font-size: 0.8em;
   color: #555;
   margin-bottom: 5px;
}

.acceptance-value {
   font-weight: bold;
}

.yes {
   color: green;
}

.no {
   color: orange;
}

.checkbox-label {
   display: inline-flex;
   /* Changed to inline-flex for better alignment in the cell */
   align-items: center;
   cursor: pointer;
   font-weight: 500;
   color: #333;
}

/* Hide the default browser checkbox */
.styled-checkbox {
   display: none;
}

/* The custom checkbox container */
.checkbox-custom {
   width: 20px;
   height: 20px;
   border: 2px solid #00bcd4;
   border-radius: 4px;
   margin-right: 12px;
   display: inline-block;
   position: relative;
   transition: background-color 0.2s, border-color 0.2s;
}

/* Create the checkmark/tick using a pseudo-element */
.checkbox-custom::after {
   content: '';
   position: absolute;
   display: none;
   left: 6px;
   top: 2px;
   width: 5px;
   height: 10px;
   border: solid white;
   border-width: 0 3px 3px 0;
   transform: rotate(45deg);
}

/* Style the custom checkbox when checked */
.styled-checkbox:checked+.checkbox-custom {
   background-color: #00bcd4;
   border-color: #00bcd4;
}

/* Show the checkmark when the checkbox is checked */
.styled-checkbox:checked+.checkbox-custom::after {
   display: block;
}

/* START: UPDATED CSS FOR "SHARED WITH" SECTION */
.shared-users-list {
   margin-top: 5px;
}

.shared-user-item-inline {
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 0.3rem 0;
   /* Add a border for separation if you have multiple users */
   border-bottom: 1px solid #f0f0f0;
}

.shared-user-item-inline:last-child {
   border-bottom: none;
   /* Remove border from the last item */
}

.shared-user-email {
   color: #435666;
   font-size: 0.9em;
}

.share-type-badge {
   background-color: #e9ecef;
   color: #495057;
   padding: 0.25rem 0.75rem;
   border-radius: 10px;
   font-size: 0.8em;
   font-weight: bold;
   text-transform: capitalize;
}


.form-control-static-container {
   min-height: 40px;
   padding: 0.6rem 0.75rem;
   font-size: 1rem;
   font-weight: 400;
   line-height: 1.5;
   color: #435666;
   background-color: #e9ecef;
   border: 1px solid #ced4da;
   border-radius: 10px;
   opacity: 1;
}

.shared-users-list {
   margin-top: 0;
}
</style>